import { ThemeProvider } from 'styled-components';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from 'react-query';
import { Container } from './styles';
import defaultTheme from '../../assets/styles/themes/default';
import AppRoutes from '../../routes';
import GlobalStyles from '../../assets/styles/global';
import Header from '../Header';
import { queryClient } from '../../datasources/queryClient';
// import { HeaderMargin } from '../HeaderMargin';
import AuthInterceptor from '../AuthInterceptor';
import { AuthProvider } from '../../context/Auth';
import useAuth from '../../hooks/useAuth';

export default function App() {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={defaultTheme}>
          <GlobalStyles />
          <AuthProvider>
            <AuthInterceptor>
              <Layout />
            </AuthInterceptor>
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>

  );
}

function Layout() {
  const { isAuthenticated } = useAuth();

  return (
    <>
      {isAuthenticated && <Header />}
      <Container>
        <AppRoutes />
      </Container>

    </>
  );
}
